module.exports = __webpack_public_path__ + "static/img/logo_intekel.eaf4c01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/logo_intekel.png
// module id = DIbA
// module chunks = 69